import React from "react";
import i18n from "i18next";
import PropTypes from "prop-types";
import { fetchStoreData } from "~/assets/js/Api/storeApi";

export const OrderType = ({ order, isPickup, storeId }) => {
    const { isLoading, storePickupAddress } = fetchStoreData(storeId);
    const { iconPath } = reactConfig;

    const deliveryAddress = order?.shipping?.address
        ? `${order.shipping.address}, ${order.shipping.postcode} ${order.shipping.city}`
        : "";
    const deliveryText = `${i18n.t("delivery.delivery")} ${i18n.t(
        "delivery.to"
    )} ${deliveryAddress}`;

    const pickupText = `${i18n.t("delivery.pickup")} ${i18n.t(
        "delivery.in"
    )} ${storePickupAddress}`;

    const icon = !isPickup
        ? `${iconPath}/bicycle-new.svg`
        : `${iconPath}/shop-new.svg`;

    const text = !isPickup ? deliveryText : pickupText;

    return (
        <div className="togglebox">
            {!isLoading && (
                <>
                    <img src={icon} className={"togglebox__icon"}></img>
                    <span className="togglebox__title ph-no-capture">
                        {text}
                    </span>
                </>
            )}
        </div>
    );
};

OrderType.propTypes = {
    order: PropTypes.object.isRequired,
    isPickup: PropTypes.bool.isRequired,
    storeId: PropTypes.number,
};

export default OrderType;
